import ResourceTable from '../../../containers/core/ResourceTable';
import { DOSSIER_CONTACTS_WORKED_FOR_SAME_SCHOOL_RESOURCE } from '../../../resources/dossier.contacts.worked.for.same.school.resource';
import { contacts } from '../../../services/bff.api';

const StakeholderAddWorkedForSameSchoolTab = ({ dossierId, dossierSchools, selected, onSelect }) => {
  const contactsWorkedForSameSchoolResource = {
    ...DOSSIER_CONTACTS_WORKED_FOR_SAME_SCHOOL_RESOURCE,
    table: {
      ...DOSSIER_CONTACTS_WORKED_FOR_SAME_SCHOOL_RESOURCE.table,
      highlight: (item) => selected?.id === item.id,
      highlightType: 'success',
      disablePagination: true
    },
    api: {
      get: () =>
        contacts.getWorkedForSchoolInAnotherDossier({
          schoolIds: dossierSchools?.map((s) => s?.schoolId)?.filter((id) => !!id) ?? [],
          dossierId
        })
    }
  };

  return <ResourceTable resource={contactsWorkedForSameSchoolResource} onRowClick={onSelect} />;
};

export default StakeholderAddWorkedForSameSchoolTab;
